<template>
  <el-container class="login-container">
    <el-main class="login-main">
      <div class="box-card">
        <div class="box-card-container">
          <div class="login-title">登录</div>
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-width="0px"
            class="login-form"
          >
            <el-form-item label prop="name">
              <el-input v-model="form.name" placeholder="用户名"></el-input>
            </el-form-item>
            <el-form-item label prop="password">
              <el-input
                v-model="form.password"
                type="password"
                placeholder="密码"
                v-on:keyup.enter.native="onSubmit"
              ></el-input>
            </el-form-item>
            <el-form-item label prop="captcha">
              <el-input
                class="i-captcha"
                v-model="form.captcha"
                placeholder="输入验证码"
              ></el-input>
              <img
                :src="'data:image/png;base64,' + ico"
                class="avatar"
                @click="refreshIco()"
              />
            </el-form-item>
            <div style="color:#AAA;float:right;">
              记住用户名密码：
              <el-switch v-model="isRemember"> </el-switch>
            </div>
            <el-form-item class="radio-class">
              <el-radio v-model="radio" :label="0">我是管理员</el-radio>
              <el-radio v-model="radio" :label="1">我是代理商</el-radio>
              <el-radio v-model="radio" :label="2">我是加盟商</el-radio>
            </el-form-item>
            <el-form-item style="margin-top:132px;">
              <el-button
                type="primary"
                class="login-btn"
                round
                @click="onSubmit"
                >登录</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <CopyRight :className="'footer'" />
    </el-main>
  </el-container>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      form: {
        name: "",
        password: "",
        captcha: "",
        captchaId: ""
      },
      ico: "",
      rules: {
        name: [{ required: true, message: "请输入用户名" }],
        password: [{ required: true, message: "请输入密码" }],
        captcha: [{ required: true, message: "请输入验证码" }]
      },
      isRemember: false,
      radio: 0
    };
  },
  methods: {
    onSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let data = {
            password: this.form.password,
            captchaId: this.form.captchaId,
            captcha: this.form.captcha
          };
          if (this.radio == 0) {
            data.adminName = this.form.name;
          } else if (this.radio == 1) {
            data.agentLoginAccount = this.form.name;
          } else if (this.radio == 2) {
            data.vendorLoginAccount = this.form.name;
          }
          let loginUrl = "";
          switch (this.radio) {
            case 0:
              loginUrl = "/api/administrator/login";
              break;
            case 1:
              loginUrl = "/api/agent/login";
              break;
            case 2:
              loginUrl = "/api/vendor/login";
              break;
            default:
              break;
          }
          this.$axios(loginUrl, {
            data
          })
            .then(data => {
              // this.$store.commit("setUserInfo", data);
              //let { token } = data;
              //this.$setToken(token, data);
              // localStorage.setItem("token", data.token);
              localStorage.setItem("userInfo", JSON.stringify(data));
              // console.log(localStorage.getItem("userInfo"));
              //Cookies.set("userInfo", data, { expires: 365 });
              if (this.isRemember) {
                Cookies.set(
                  "userAndPassword",
                  {
                    name: this.form.name,
                    pass: escape(this.form.password),
                    isRemember: this.isRemember
                  },
                  { expires: 7 }
                );
              } else {
                Cookies.remove("userAndPassword");
              }
              this.$notify({
                title: "成功",
                message: "恭喜您登录成功",
                type: "success"
              });
              this.$nextTick(() => {
                this.$router.push({
                  name: "home"
                });

                // this.$getAllMachineModelInfoList();
                // this.$getAllAgentIDName();
                // this.$getAllVendorIDName();
                // this.$getAllShopIDName();
              });
            })
            .catch(error => {
              console.log(error);
              this.refreshIco();
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    refreshIco() {
      this.$axios(this.$urlMapping["获取验证码"], {
        data: {}
      }).then(x => {
        console.log(x);
        this.ico = x.base64;
        this.form.captchaId = x.captchaId;
      });
    }
  },
  mounted() {
    if (Cookies.getJSON("userAndPassword")) {
      let result = Cookies.getJSON("userAndPassword");
      this.form.name = result.name;
      this.form.password = unescape(result.pass);
      this.isRemember = result.isRemember;
    }

    this.refreshIco();
  }
};
</script>

<style lang="less" scoped>
.login-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .login-header {
    img {
      vertical-align: middle;
    }
    p {
      display: inline-block;
      vertical-align: middle;
      font-size: 20px;
      margin-left: 1em;
    }
  }
  .login-main {
    flex-grow: 1;
    background-image: url("../../assets/img/bg-login@2x.png");
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .box-card {
      width: 900px;
      height: 470px;
      background-image: url("../../assets/img/login_box@2x.png");
      display: flex;
      flex-direction: row-reverse;
      .box-card-container {
        width: 406px;
        height: 100%;
        background: white;
        .login-title {
          font-size: 24px;
          color: #df40ff;
          margin-top: 60px;
          margin-left: 46px;
        }
        .login-form {
          width: 330px;
          margin-left: 46px;
          margin-top: 50px;
          /deep/ .el-input__inner {
            border-top: none;
            border-left: none;
            border-right: none;
            border-radius: 0;
            padding-left: 18px;
          }
        }
      }
    }
    .login-btn {
      width: 100%;
      height: 60px;
      font-size: 20px;
      border-radius: 30px;
    }
    .login-icon {
      text-align: center;
      color: #f72c2c;
      margin-bottom: 20px;
      i {
        font-size: 72px;
      }
    }
    .i-captcha {
      width: calc(100% - 135px);
    }
  }
  .radio-class {
    float: left;
    position: relative;
    top: 20px;
    left: 0px;
  }

  /deep/ .el-radio__label {
    font-size: 12px;
  }
}
</style>
